import API from 'aurora-api';
import * as urls from 'aurora-api/dotNetUrls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(BASE_URL);
const downloadAPI = new API(BASE_URL, null, {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  responseType: 'blob',
});
class musatahaContractRegistrationService {
  static registerApplication = data => api.post(urls.WORKFLOW.INITIATE_APPLICATION, data);

  static uploadDocument = data => api.post(`${urls.MUSATAHA_REGISTRATION.UPLOAD_DOCUMENT}`, data);

  static downloadDocument = data => api.get(urls.DOCUMENT.DOWNLOAD_DOCUMENT, null, data);

  static deleteDocument = id => api.delete(`${urls.DOCUMENT.DELETE_DOCUMENT}/${id}`);

  static fetchApplication = id => api.get(urls.WORKFLOW.FETCH_APPLICATION, id);

  static getPermissions = () => api.get(urls.MUSATAHA_REGISTRATION.PERMISSIONS);

  static calculateFees = (id, amount) => api.get(`${urls.MUSATAHA_REGISTRATION.CALCULATE_FEES}/${id}?amount=${amount}`);

  static fetchFees = id => api.get(`${urls.MUSATAHA_REGISTRATION.FETCH_FEES}/${id}`);

  static saveMusatahaContractApplication = data => api.post(urls.MUSATAHA_REGISTRATION.SAVE_APPLICATION, data);

  static checkoutMusatahaContractApplication = data => api.post(urls.WORKFLOW.CHECKOUT_APPLICATION, data);

  static deleteMusateh = (applicationId, idDetails) =>
    api.delete(`${urls.MUSATAHA_REGISTRATION.DELETE_MUSATEH}/${applicationId}?${idDetails}`);

  static addMusateh = data => api.post(urls.MUSATAHA_REGISTRATION.ADD_MUSATEH, data);

  static updateMusateh = data => api.put(urls.MUSATAHA_REGISTRATION.UPDATE_MUSATEH, data);

  static saveValuationCertificateUnitApplication = data =>
    api.post(urls.CERTIFICATE.VALUATION_UNIT_SAVE_APPLICATION, data);

  static checkoutApplication = data => api.post(urls.WORKFLOW.CHECKOUT_APPLICATION, data);

  static cancelApplication = (id, params = { status: 'DISCARD' }) =>
    api.post(urls.WORKFLOW.CANCEL_APPLICATION, null, params, id);

  static checkValidation = data => api.post(urls.WORKFLOW.PRE_VALIDATE, data);

  static getEvaluationReasons = () => api.get(urls.CERTIFICATE.EVALUATION_REASONS);

  static getPaymentBreakdown = id => api.get(urls.CERTIFICATE.VALUATION_CERTIFICATE_PAYMENT_BREAKDOWN, id);

  static paymentSuccess = id => api.get(`${urls.MUSATAHA_REGISTRATION.FETCH_FEES}/${id}/success`);

  static downloadCertificate = data => api.get(urls.MUSATAHA_REGISTRATION.DOWNLOAD_CERTIFICATE_MUSATAHA, null, data);

  static downloadCertificateValuationUnit = id => api.get(urls.CERTIFICATE.DOWNLOAD_CERTIFICATE_VALUATION_UNIT, id);

  static approvalAndReturnApplication = ({ data, flow }) => api.post(urls.MUSATAHA_REGISTRATION[flow], data);

  static downloadIndividualMusatahaContract = contractNo =>
    downloadAPI.get(`${urls.MUSATAHA_REGISTRATION.DOWNLOAD_INDIVIDUAL_CONTRACT}?contractNumber=${contractNo}`);
}

export default musatahaContractRegistrationService;
